import {
  HeartPulse,
  ListChecks,
  Gift,
  Wind,
  Salad,
  Plane,
  Clapperboard,
  BellRing,
} from "lucide-react";
import Reveal from "./Reveal";

const modules = [
  {
    icon: HeartPulse,
    tag: "Everyday wellness",
    title: "Today's health tip",
    body: "A fresh, gently-written wellness tip each morning — from hydration to sleep — crafted to fit the life you're actually living.",
    span: "md:col-span-7",
    feature: true,
  },
  {
    icon: ListChecks,
    tag: "Focus",
    title: "To-do & tasks",
    body: "Capture what matters and let the small things go. A calm, uncluttered list you'll actually want to open.",
    span: "md:col-span-5",
  },
  {
    icon: Gift,
    tag: "People",
    title: "Birthdays & anniversaries",
    body: "Never miss a moment that matters to the people you love.",
    span: "md:col-span-4",
  },
  {
    icon: Wind,
    tag: "Calm",
    title: "Stress relief",
    body: "Breathe, pause, and soften the edges of a heavy day.",
    span: "md:col-span-4",
  },
  {
    icon: Salad,
    tag: "Nourish",
    title: "Food & meals",
    body: "Keep track of how you nourish yourself, gently.",
    span: "md:col-span-4",
  },
  {
    icon: Plane,
    tag: "Escape",
    title: "Vacation planning",
    body: "Dream, plan and hold on to the trips that light you up — from a weekend away to the journey of a lifetime.",
    span: "md:col-span-6",
  },
  {
    icon: Clapperboard,
    tag: "Unwind",
    title: "Movies",
    body: "A watchlist for slow evenings.",
    span: "md:col-span-3",
  },
  {
    icon: BellRing,
    tag: "Presence",
    title: "Reminders",
    body: "Quiet nudges, right on time.",
    span: "md:col-span-3",
  },
];

const Card = ({ m, i }) => {
  const Icon = m.icon;
  return (
    <Reveal delay={i * 0.05} className={m.span}>
      <div
        data-testid={`feature-card-${i}`}
        className="group h-full bg-[#EDE8DF] rounded-[2rem] p-8 md:p-10 border border-[#2B2B26]/5 transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_24px_50px_rgb(43,43,38,0.08)] hover:bg-[#E5DFD4]"
      >
        <div className="flex items-center justify-between mb-8">
          <span className="flex items-center justify-center w-12 h-12 rounded-full bg-[#F8F7F1] text-[#1877F2] transition-transform duration-500 group-hover:scale-110">
            <Icon strokeWidth={1.5} className="w-5 h-5" />
          </span>
          <span className="font-body text-[10px] uppercase tracking-[0.2em] text-[#2B2B26]/45">
            {m.tag}
          </span>
        </div>
        <h3
          className={`font-serif text-[#2B2B26] ${
            m.feature ? "text-3xl sm:text-4xl" : "text-2xl sm:text-3xl"
          }`}
        >
          {m.title}
        </h3>
        <p className="font-body text-base leading-relaxed text-[#2B2B26]/70 mt-3 max-w-md">
          {m.body}
        </p>
      </div>
    </Reveal>
  );
};

export const Features = () => (
  <section id="features" className="py-24 md:py-32" data-testid="features-section">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14 md:mb-20">
        <Reveal>
          <div>
            <p className="font-body text-xs sm:text-sm uppercase tracking-[0.25em] text-[#2B2B26]/60 mb-5">
              One home, gently arranged
            </p>
            <h2 className="font-serif font-light tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.15] text-[#2B2B26] max-w-2xl">
              Everything you carry, held in one calm place.
            </h2>
          </div>
        </Reveal>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
        {modules.map((m, i) => (
          <Card key={m.title} m={m} i={i} />
        ))}
      </div>
    </div>
  </section>
);

export default Features;
